/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown>, reps: NonNullable<unknown> }} Offline_Set_LoadInputs */

const en_us2_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_br2_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const es_419_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_pt2_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const fr_fr2_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const de_de2_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const it_it2_offline_set_load = /** @type {(inputs: Offline_Set_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{loadText} × {reps}" |
*
* @param {Offline_Set_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_set_load = /** @type {((inputs: Offline_Set_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Set_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_set_load(inputs)
	if (locale === "es-419") return es_419_offline_set_load(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_set_load(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_set_load(inputs)
	if (locale === "de-DE") return de_de2_offline_set_load(inputs)
	if (locale === "it-IT") return it_it2_offline_set_load(inputs)
	return en_us2_offline_set_load(inputs)
});
export { offline_set_load as "offline.set_load" }